import useAPI from '@/hooks/useAPI';
import RemitRepository from '@/repositories/RemitRepository';

const useRemitQuery = (id: string, enabled = true) => {
  const remitRepo = RemitRepository();

  return useAPI({
    enabled,
    queryKey: ['getRemit', id],
    queryFn: async () => {
      return await remitRepo.getRemit({
        remitID: id || ''
      });
    }
  });
};

export default useRemitQuery;
